import { AppThunk } from 'redux/store'
import { getTimer, timerCreated, resetTimer, Timer } from '.'

export const createTimer = (timerName: Timer, time: number, callback: () => void): AppThunk => async dispatch => {
    if (time > 0x7fffffff) {
        // setTimeout limit is MAX_INT32=(2^31-1)
        return
    }

    dispatch(
        timerCreated({
            name: timerName,
            id: setTimeout(() => {
                callback()
                dispatch(resetTimer(timerName))
            }, time),
        }),
    )
}

export const clearTimeoutFromStore = (timerName: Timer): AppThunk => async (dispatch, getState) => {
    const timer = getTimer(getState(), timerName)
    if (timer) {
        clearTimeout(timer)
        dispatch(resetTimer(timerName))
    }
}
